import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from '@material-ui/core'
import LabelImportantIcon from '@material-ui/icons/LabelImportant'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import { viewPackageStyles } from './Styles'
import { useStyles } from '../Styles'
import { getStatusIcon } from '../../../utils/helpers'
import packageFormats from '../../../configurations/package-format'
import packageTypes from '../../../configurations/package-types'
import requestorTypes from '../../../configurations/package-requestor-type'
import packageStatus from '../../../configurations/package-status'
import receiverTypes from '../../../configurations/receiver-types'

const PackageDetails = ({ currentData, locale }) => {
  const classes = viewPackageStyles()
  const packageClasses = useStyles()

  const getCodeItemData = (key, value) => {
    if (!!key) {
      switch (key) {
        case 'submissionDate':
        case 'deletionDate':
          return <div className={'cellDataWrapper'}>
            <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                            format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
            <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                          format="hh:mm A">{value}</Moment></span>
          </div>

        case 'dateFrom':
        case 'dateTo':
          return <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                         format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment>

        case 'format':
          let format = packageFormats?.filter(item => item.id?.toString() === value?.toString())
          return !!format?.length && format[0].name

        case 'type':
          let type = packageTypes?.filter(item => item.id?.toString() === value?.toString())
          return !!type?.length && type[0][`name_${locale}`]

        case 'requestorType':
          let requestorType = requestorTypes?.filter(item => item.id?.toString() === value?.toString())
          return !!requestorType?.length && requestorType[0][`name_${locale}`]

        case 'itemCodes':
          let itemCodes = !!value ? JSON.parse(value) : null
          itemCodes = itemCodes?.ItemCodes || []
          return !!itemCodes?.length && itemCodes.map(item => <div>{`${item?.CodeValue} (${item?.CodeType})`}</div>)

        case 'receiverSenderType':
          let receiverType = receiverTypes?.filter(item => item.key?.toString() === value?.toString())
          return !!receiverType?.length && receiverType[0][`name_${locale}`]


        case 'status':
          let status = packageStatus?.filter(item => item.id?.toString() === value?.toString())
          return !!status && !!status.length &&
            <div
              className={packageClasses.statusWrapper + ` ${status[0]['key']?.toString()?.toLowerCase()}`}>
              {getStatusIcon(status[0]['key'])}
              <strong>{status[0][`name_${locale}`]}</strong>
            </div>

        default:
          return value
      }
    } else {
      return ''
    }
  }
  return (
    <div className={classes.RequestDataWrapper}>
      {!!currentData && !!Object.keys(currentData).length &&
      <div className={classes.RequestDataContainer}>
        {Object.keys(currentData || {})?.map((groupKey, index) => (
          !!Object.keys(currentData[groupKey] || {})?.length &&
          <Accordion defaultExpanded={true} key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.RequestHeading}><LabelImportantIcon/><FormattedMessage
                id={`Package.group.title.${groupKey}`}/></Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className={classes.RequestInfoWrapper}>
                {Object.keys(currentData[groupKey] || {})?.map((itemKey, itemIndex) => (
                  !['documentFormat'].includes(itemKey) && !!currentData[groupKey][itemKey] &&
                  <React.Fragment key={itemIndex}>
                    <Grid item xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
                      <Grid item xs={12} sm={5} className={classes.infoItemLabel}>
                        <FormattedMessage id={`Fields.label.view.Package.${itemKey}`}/>
                      </Grid>
                      <Grid item xs={12} sm={7} className={classes.infoItemValue}>
                        {getCodeItemData(itemKey, currentData[groupKey][itemKey])}
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        ))}

      </div>
      }
    </div>
  )
}

export default PackageDetails
